import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Compact Indian-currency formatter: ≥1 Cr / ≥1 L abbreviated, else grouped
// to 2 decimals. Returns '-' for null/undefined/NaN.
export const formatIndianNumber = (num?: number) => {
  if (num === null || num === undefined || isNaN(num)) return '-';
  const absNum = Math.abs(num);
  if (absNum >= 1_00_00_000) {
    return `${(num / 1_00_00_000).toFixed(2)} Cr`;
  } else if (absNum >= 1_00_000) {
    return `${(num / 1_00_000).toFixed(2)} L`;
  }
  return num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

// Local-time [start, end] Date window for a "YYYY-YYYY+1" financial year
// (e.g. "2026-2027" -> 01 Apr 2026 .. 31 Mar 2027). Returns null if the label
// isn't a well-formed FY string.
export const fyDateRange = (year?: string): { start: Date; end: Date } | null => {
  const m = year?.match(/^(\d{4})-(\d{4})$/);
  if (!m) return null;
  const startYear = Number(m[1]);
  return {
    start: new Date(startYear, 3, 1),       // 01 Apr of the first year
    end: new Date(startYear + 1, 2, 31),    // 31 Mar of the next year
  };
};

export const formatDayOrdinal = (day: number) => {
  if (day % 100 >= 11 && day % 100 <= 13) {
    return `${day}th`;
  }

  switch (day % 10) {
    case 1:
      return `${day}st`;
    case 2:
      return `${day}nd`;
    case 3:
      return `${day}rd`;
    default:
      return `${day}th`;
  }
};